// import { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import ReCAPTCHA from "react-google-recaptcha";

// export default function HiringPage() {
//   const [formData, setFormData] = useState({
//     name: "",
//     address: "",
//     phoneNumber: "",
//     licenseNumber: "",
//     aadharNumber: "",
//     description: "",
//     jobId: "",
//   });

//   const [captchaToken, setCaptchaToken] = useState(null);
// const API_BASE_URL = process.env.REACT_APP_TRACKK_URL;
// const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

//   const captchaRef = useRef(null);

//   const validateForm = () => {
//     const phoneRegex = /^[0-9]{10}$/;
//     const aadharRegex = /^[0-9]{12}$/;

//     if (!phoneRegex.test(formData.phoneNumber)) {
//       alert("Please enter a valid 10-digit Phone Number");
//       return false;
//     }
//     if (!aadharRegex.test(formData.aadharNumber)) {
//       alert("Please enter a valid 12-digit Aadhar Number");
//       return false;
//     }

//     return true;
//   };

//   const [jobs, setJobs] = useState([]);

//   useEffect(() => {
//     const fetchJobs = async () => {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/api/v1/jobs`);
//         const jobsArray = Array.isArray(response.data)
//           ? response.data
//           : response.data.jobs;
//         setJobs(jobsArray.filter((job) => job.status === "Open"));
//       } catch (error) {
//         console.error("Failed to fetch jobs:", error);
//       }
//     };
//     fetchJobs();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleCaptchaChange = (token) => {
//     setCaptchaToken(token);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     if (!captchaToken) {
//       alert("Please verify the CAPTCHA to continue!");
//       return;
//     }

//     try {
//       const response = await axios.post(
//         `${API_BASE_URL}/api/v1/applicants`,
//         { ...formData, captchaToken }, // ⬅️ REQUIRED CHANGE
//         { headers: { "Content-Type": "application/json" } }
//       );

//       if (response.status === 201) {
//         alert("Application submitted successfully!");
//         setFormData({
//           name: "",
//           address: "",
//           phoneNumber: "",
//           licenseNumber: "",
//           aadharNumber: "",
//           description: "",
//           jobId: "",
//         });
//         captchaRef.current.reset();
//         setCaptchaToken(null);
//       } else {
//         alert("Something went wrong. Please try again.");
//       }
//     } catch (error) {
//       console.error(error);
//       alert(
//         error.response?.data?.message ||
//           "Server error. Please check your connection."
//       );
//     }
//   };

//   return (
//     <div className="hiring-page">
//       <div className="form-card">
//         <h2>Job Application</h2>
//         <form onSubmit={handleSubmit}>
//           <div className="form-grid">
//             <div className="form-group">
//               <label>Full Name</label>
//               <input
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 placeholder="John Doe"
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>Address</label>
//               <input
//                 type="text"
//                 name="address"
//                 value={formData.address}
//                 onChange={handleChange}
//                 placeholder="123 Main St"
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>Phone</label>
//               <input
//                 type="number"
//                 name="phoneNumber"
//                 value={formData.phoneNumber}
//                 onChange={handleChange}
//                 placeholder="1234567890"
//                 onInput={(e) =>
//                   (e.target.value = e.target.value
//                     .replace(/\D/g, "")
//                     .slice(0, 10))
//                 }
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>Aadhar</label>
//               <input
//                 type="number"
//                 name="aadharNumber"
//                 value={formData.aadharNumber}
//                 onChange={handleChange}
//                 placeholder="123412341234"
//                 onInput={(e) =>
//                   (e.target.value = e.target.value
//                     .replace(/\D/g, "")
//                     .slice(0, 12))
//                 }
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>License</label>
//               <input
//                 type="text"
//                 name="licenseNumber"
//                 value={formData.licenseNumber}
//                 onChange={handleChange}
//                 placeholder="AB1234567"
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>Job</label>
//               <select
//                 name="jobId"
//                 value={formData.jobId}
//                 onChange={handleChange}
//                 required
//               >
//                 <option value="">-- Select Job --</option>
//                 {jobs.map((job) => (
//                   <option key={job._id} value={job._id}>
//                     {job.title} - {job.city}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="form-group full-width">
//               <label>Description</label>
//               <textarea
//                 name="description"
//                 value={formData.description}
//                 onChange={handleChange}
//                 placeholder="Tell us about yourself..."
//                 rows={3}
//               />
//             </div>
//           </div>

//           <div className="captcha-container">
//             <ReCAPTCHA
//               sitekey={SITE_KEY}
//               onChange={handleCaptchaChange}
//               ref={captchaRef}
//             />
//           </div>

//           <button type="submit" className="btn">
//             Submit Application
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }

// import { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import ReCAPTCHA from "react-google-recaptcha";

// export default function HiringPage() {
//   const [formData, setFormData] = useState({
//     name: "",
//     address: "",
//     phoneNumber: "",
//     licenseNumber: "",
//     aadharNumber: "",
//     description: "",
//     jobId: "",
//   });

//   const [selectedJob, setSelectedJob] = useState(null);
//   const [captchaToken, setCaptchaToken] = useState(null);
//   const [fieldErrors, setFieldErrors] = useState({});
//   const [status, setStatus] = useState("idle"); // idle | submitting | success | error
//   const [statusMessage, setStatusMessage] = useState("");
//   const [jobs, setJobs] = useState([]);

//   const API_BASE_URL = process.env.REACT_APP_TRACKK_URL;
//   const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
//   const captchaRef = useRef(null);

//   useEffect(() => {
//     const fetchJobs = async () => {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/api/v1/jobs`);
//         const jobsArray = Array.isArray(response.data)
//           ? response.data
//           : response.data.jobs;
//         setJobs(jobsArray.filter((job) => job.status === "Open"));
//       } catch (error) {
//         console.error("Failed to fetch jobs:", error);
//       }
//     };
//     fetchJobs();
//   }, []);

//   const validateForm = () => {
//     const phoneRegex = /^[0-9]{10}$/;
//     const aadharRegex = /^[0-9]{12}$/;
//     const errors = {};

//     if (!phoneRegex.test(formData.phoneNumber)) {
//       errors.phoneNumber = "Enter a valid 10-digit phone number.";
//     }
//     if (!aadharRegex.test(formData.aadharNumber)) {
//       errors.aadharNumber = "Enter a valid 12-digit Aadhar number.";
//     }
//     if (!captchaToken) {
//       errors.captcha = "Verify the CAPTCHA to continue.";
//     }

//     setFieldErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({ ...prev, [name]: value }));

//     if (fieldErrors[name]) {
//       setFieldErrors((prev) => ({ ...prev, [name]: undefined }));
//     }

//     if (name === "jobId") {
//       const job = jobs.find((j) => j._id === value);
//       setSelectedJob(job || null);
//     }
//   };

//   const formatPostingDetails = (text) => {
//   if (!text) return null;

//   // Keep label and value on the same line
//   text = text
//   .replace(/Experience:\s*\n*\s*/gi, "Experience: ")
//   .replace(/Employment Type:\s*\n*\s*/gi, "Employment Type: ")
//   .replace(
//     /(Experience:\s*.*?)(\s+Employment Type:)/i,
//     "$1\n$2"
//   );

//   const sections = [
//     "About Us",
//     "Key Responsibilities",
//     "Required Skills",
//     "Preferred",
//     "What We Offer",
//   ];

//   let formatted = text;

//   sections.forEach((section) => {
//     formatted = formatted.replace(
//       new RegExp(section, "g"),
//       `##${section}##`
//     );
//   });

//   const parts = formatted.split("##").filter(Boolean);

//   return (
//     <>
//       {/* Experience & Employment Type */}
//       {parts[0] && (
//         <div style={{ marginBottom: "16px", lineHeight: "1.8" }}>
//           {parts[0]
//             .trim()
//             .split("\n")
//             .filter(Boolean)
//             .map((line, i) => (
//               <div key={i}>{line}</div>
//             ))}
//         </div>
//       )}

//       {/* Remaining Sections */}
//       {parts.slice(1).map((part, index) => {
//         const lines = part
//           .split(". ")
//           .map((l) => l.trim())
//           .filter(Boolean);

//         return (
//           <div key={index} style={{ marginBottom: "16px" }}>
//             <strong>{lines[0]}</strong>

//             <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//               {lines.slice(1).map((line, i) => (
//                 <li key={i}>{line.replace(/\.$/, "")}</li>
//               ))}
//             </ul>
//           </div>
//         );
//       })}
//     </>
//   );
// };

//   const handleCaptchaChange = (token) => {
//     setCaptchaToken(token);
//     if (token) {
//       setFieldErrors((prev) => ({ ...prev, captcha: undefined }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     setStatus("submitting");
//     setStatusMessage("");

//     try {
//       const response = await axios.post(
//         `${API_BASE_URL}/api/v1/applicants`,
//         { ...formData, captchaToken },
//         { headers: { "Content-Type": "application/json" } },
//       );

//       if (response.status === 201) {
//         setStatus("success");
//         setStatusMessage("Application submitted. We'll be in touch soon.");
//         setFormData({
//           name: "",
//           address: "",
//           phoneNumber: "",
//           licenseNumber: "",
//           aadharNumber: "",
//           description: "",
//           jobId: "",
//         });
//         setSelectedJob(null);
//         captchaRef.current?.reset();
//         setCaptchaToken(null);
//       } else {
//         setStatus("error");
//         setStatusMessage("Something went wrong. Please try again.");
//       }
//     } catch (error) {
//       console.error(error);
//       setStatus("error");
//       setStatusMessage(
//         error.response?.data?.message ||
//           "Server error. Please check your connection and try again.",
//       );
//     }
//   };

//   const digitsOnly = (max) => (e) => {
//     e.target.value = e.target.value.replace(/\D/g, "").slice(0, max);
//   };

//   return (
//     <div className="hp-page">
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@400;500;600&display=swap');

//         .hp-page {
//           --ink: #10192E;
//           --ink-soft: #1B2946;
//           --ink-line: rgba(247,245,241,0.14);
//           --paper: #F6F4EF;
//           --card: #FFFFFF;
//           --brass: #C08A3E;
//           --brass-dark: #9C6F2E;
//           --text: #1B1F27;
//           --muted: #6B7280;
//           --border: #E4E0D6;
//           --success: #2F6F4E;
//           --success-bg: #EAF3EC;
//           --error: #B3432B;
//           --error-bg: #FBECE7;

//           font-family: 'Inter', -apple-system, sans-serif;
//           background: var(--paper);
//           color: var(--text);
//           min-height: 100vh;
//           padding: 48px 24px;
//           box-sizing: border-box;
//         }
//         .hp-page *, .hp-page *::before, .hp-page *::after { box-sizing: border-box; }

//         .hp-shell {
//           max-width: 760px;
//           margin: 0 auto;
//           background: var(--card);
//           border-radius: 4px;
//           overflow: hidden;
//           box-shadow: 0 30px 60px -25px rgba(16,25,46,0.25);
//           border: 1px solid var(--border);
//         }

//         .hp-eyebrow {
//           font-family: 'JetBrains Mono', monospace;
//           font-size: 11px;
//           letter-spacing: 0.18em;
//           text-transform: uppercase;
//           color: var(--brass-dark);
//           margin: 0 0 10px;
//         }

//         /* ---------- Job ticket (light, right-aligned, conditional) ---------- */
//         .hp-ticket-wrap {
//           display: flex;
//           justify-content: flex-end;
//           grid-column: 1 / -1;
//         }
//         .hp-ticket {
//           width: 100%;
//           background: #FBF8F2;
//           border-radius: 4px;
//           border: 1px solid var(--border);
//           overflow: hidden;
//           animation: hp-rise 0.3s ease;
//         }
//         @keyframes hp-rise {
//           from { opacity: 0; transform: translateY(6px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         .hp-ticket-top {
//           padding: 18px 20px 16px;
//           display: flex;
//           justify-content: space-between;
//           align-items: flex-start;
//           gap: 12px;
//         }
//         .hp-ticket-label {
//           font-family: 'JetBrains Mono', monospace;
//           font-size: 10px;
//           letter-spacing: 0.16em;
//           text-transform: uppercase;
//           color: var(--brass-dark);
//           margin: 0 0 8px;
//         }
//         .hp-ticket-title {
//           font-family: 'Space Grotesk', sans-serif;
//           font-size: 18px;
//           font-weight: 600;
//           margin: 0 0 4px;
//           color: var(--text);
//         }
//         .hp-ticket-city {
//           font-size: 13px;
//           color: var(--muted);
//           margin: 0;
//         }
//         .hp-ticket-clear {
//           background: none;
//           border: none;
//           font-size: 12px;
//           color: var(--muted);
//           text-decoration: underline;
//           cursor: pointer;
//           padding: 2px 0;
//           font-family: 'Inter', sans-serif;
//           white-space: nowrap;
//         }
//         .hp-ticket-clear:hover { color: var(--error); }
//         .hp-ticket-divider {
//           position: relative;
//           border-top: 1px dashed var(--border);
//         }
//         .hp-ticket-divider::before,
//         .hp-ticket-divider::after {
//           content: "";
//           position: absolute;
//           top: -9px;
//           width: 18px;
//           height: 18px;
//           background: var(--card);
//           border-radius: 50%;
//         }
//         .hp-ticket-divider::before { left: -9px; }
//         .hp-ticket-divider::after { right: -9px; }
//         .hp-ticket-bottom {
//           padding: 16px 20px 18px;
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 14px;
//         }
//         .hp-ticket-stat-label {
//           font-size: 10px;
//           letter-spacing: 0.1em;
//           text-transform: uppercase;
//           color: var(--muted);
//           margin: 0 0 4px;
//         }
//         .hp-ticket-stat-value {
//           font-family: 'JetBrains Mono', monospace;
//           font-size: 13.5px;
//           color: var(--text);
//           margin: 0;
//         }
//         .hp-ticket-notes {
//           padding: 0 20px 20px;
//           font-size: 12.5px;
//           line-height: 1.6;
//           color: var(--muted);
//         }

//         /* ---------- Form panel ---------- */
//         .hp-form-panel { padding: 44px 44px 48px; }
//         .hp-form-panel h2 {
//           font-family: 'Space Grotesk', sans-serif;
//           font-size: 24px;
//           font-weight: 600;
//           margin: 0 0 6px;
//         }
//         .hp-form-sub {
//           font-size: 13.5px;
//           color: var(--muted);
//           margin: 0 0 30px;
//         }

//         .hp-grid {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 20px 18px;
//         }
//         .hp-field { display: flex; flex-direction: column; }
//         .hp-field.hp-full { grid-column: 1 / -1; }

//         .hp-field label {
//           font-size: 11px;
//           font-weight: 600;
//           letter-spacing: 0.08em;
//           text-transform: uppercase;
//           color: var(--muted);
//           margin-bottom: 7px;
//         }
//         .hp-field input,
//         .hp-field select,
//         .hp-field textarea {
//           font-family: 'Inter', sans-serif;
//           font-size: 14.5px;
//           color: var(--text);
//           background: var(--paper);
//           border: 1px solid var(--border);
//           border-radius: 3px;
//           padding: 11px 13px;
//           outline: none;
//           transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
//           width: 100%;
//         }
//         .hp-field input::placeholder,
//         .hp-field textarea::placeholder { color: #A8A398; }
//         .hp-mono { font-family: 'JetBrains Mono', monospace; letter-spacing: 0.02em; }

//         .hp-field input:focus,
//         .hp-field select:focus,
//         .hp-field textarea:focus {
//           border-color: var(--brass);
//           background: var(--card);
//           box-shadow: 0 0 0 3px rgba(192,138,62,0.16);
//         }
//         .hp-field.hp-invalid input,
//         .hp-field.hp-invalid select {
//           border-color: var(--error);
//         }
//         .hp-error-text {
//           font-size: 12px;
//           color: var(--error);
//           margin-top: 6px;
//         }
//         .hp-field textarea { resize: vertical; min-height: 78px; }

//         .hp-captcha-block { margin-top: 26px; }
//         .hp-captcha-wrap { display: inline-block; }

//         .hp-status {
//           margin-top: 20px;
//           padding: 12px 14px;
//           border-radius: 3px;
//           font-size: 13.5px;
//           line-height: 1.5;
//         }
//         .hp-status.hp-success { background: var(--success-bg); color: var(--success); }
//         .hp-status.hp-error { background: var(--error-bg); color: var(--error); }

//         .hp-submit {
//           margin-top: 26px;
//           width: 100%;
//           background: var(--ink);
//           color: #F7F5F1;
//           border: none;
//           border-radius: 3px;
//           padding: 14px 20px;
//           font-family: 'Space Grotesk', sans-serif;
//           font-size: 14.5px;
//           font-weight: 600;
//           letter-spacing: 0.02em;
//           cursor: pointer;
//           transition: background 0.15s ease, transform 0.1s ease;
//         }
//         .hp-submit:hover:not(:disabled) { background: var(--brass-dark); }
//         .hp-submit:active:not(:disabled) { transform: translateY(1px); }
//         .hp-submit:disabled { opacity: 0.6; cursor: not-allowed; }
//         .hp-submit:focus-visible { outline: 2px solid var(--brass); outline-offset: 2px; }

//         @media (prefers-reduced-motion: reduce) {
//           .hp-ticket { animation: none; }
//         }
//       `}</style>

//       <div className="hp-shell">
//         <div className="hp-form-panel">
//           <p className="hp-eyebrow">Careers · Application</p>
//           <h2>Job Application</h2>
//           <p className="hp-form-sub">
//             Fields marked required must be completed before you can submit.
//           </p>

//           <form onSubmit={handleSubmit} noValidate>
//             <div className="hp-grid">
//               <div className="hp-field">
//                 <label htmlFor="hp-name">Full Name</label>
//                 <input
//                   id="hp-name"
//                   type="text"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   placeholder="John Doe"
//                   required
//                 />
//               </div>

//               <div className="hp-field">
//                 <label htmlFor="hp-phone">Phone</label>
//                 <input
//                   id="hp-phone"
//                   type="tel"
//                   inputMode="numeric"
//                   name="phoneNumber"
//                   className="hp-mono"
//                   value={formData.phoneNumber}
//                   onChange={handleChange}
//                   onInput={digitsOnly(10)}
//                   placeholder="1234567890"
//                   required
//                 />
//                 {fieldErrors.phoneNumber && (
//                   <span className="hp-error-text">
//                     {fieldErrors.phoneNumber}
//                   </span>
//                 )}
//               </div>

//               <div className="hp-field hp-full">
//                 <label htmlFor="hp-address">Address</label>
//                 <input
//                   id="hp-address"
//                   type="text"
//                   name="address"
//                   value={formData.address}
//                   onChange={handleChange}
//                   placeholder="123 Main St"
//                   required
//                 />
//               </div>

//               <div
//                 className={`hp-field ${fieldErrors.aadharNumber ? "hp-invalid" : ""}`}
//               >
//                 <label htmlFor="hp-aadhar">Aadhar Number</label>
//                 <input
//                   id="hp-aadhar"
//                   type="tel"
//                   inputMode="numeric"
//                   name="aadharNumber"
//                   className="hp-mono"
//                   value={formData.aadharNumber}
//                   onChange={handleChange}
//                   onInput={digitsOnly(12)}
//                   placeholder="123412341234"
//                   required
//                 />
//                 {fieldErrors.aadharNumber && (
//                   <span className="hp-error-text">
//                     {fieldErrors.aadharNumber}
//                   </span>
//                 )}
//               </div>

//               <div className="hp-field">
//                 <label htmlFor="hp-license">License Number</label>
//                 <input
//                   id="hp-license"
//                   type="text"
//                   name="licenseNumber"
//                   className="hp-mono"
//                   value={formData.licenseNumber}
//                   onChange={handleChange}
//                   placeholder="AB1234567"
//                   required
//                 />
//               </div>

//               <div className="hp-field">
//                 <label htmlFor="hp-job">Job</label>
//                 <select
//                   id="hp-job"
//                   name="jobId"
//                   value={formData.jobId}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select a job</option>
//                   {jobs.map((job) => (
//                     <option key={job._id} value={job._id}>
//                       {job.title} - {job.city}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {selectedJob && (
//                 <div className="hp-ticket-wrap">
//                   <div className="hp-ticket">
//                     <div className="hp-ticket-top">
//                       <div>
//                         <p className="hp-ticket-label">Selected Posting</p>
//                         <h3 className="hp-ticket-title">{selectedJob.title}</h3>
//                         <p className="hp-ticket-city">{selectedJob.city}</p>
//                       </div>
//                       <button
//                         type="button"
//                         className="hp-ticket-clear"
//                         onClick={() => {
//                           setSelectedJob(null);
//                           setFormData((prev) => ({ ...prev, jobId: "" }));
//                         }}
//                       >
//                         Clear
//                       </button>
//                     </div>
//                     <div className="hp-ticket-divider" />
//                     <div className="hp-ticket-bottom">
//                       <div>
//                         <p className="hp-ticket-stat-label">Openings</p>
//                         <p className="hp-ticket-stat-value">
//                           {selectedJob.openings}
//                         </p>
//                       </div>
//                     </div>
//                     {selectedJob.postingdetails && (
//                       <div className="hp-ticket-notes">
//                         {formatPostingDetails(selectedJob.postingdetails)}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}

//               <div className="hp-field hp-full">
//                 <label htmlFor="hp-description">
//                   Description{" "}
//                   <span style={{ textTransform: "none", fontWeight: 400 }}>
//                     (optional)
//                   </span>
//                 </label>
//                 <textarea
//                   id="hp-description"
//                   name="description"
//                   value={formData.description}
//                   onChange={handleChange}
//                   placeholder="Tell us about yourself..."
//                   rows={3}
//                 />
//               </div>
//             </div>

//             <div className="hp-captcha-block">
//               <div className="hp-captcha-wrap">
//                 <ReCAPTCHA
//                   sitekey={SITE_KEY}
//                   onChange={handleCaptchaChange}
//                   ref={captchaRef}
//                 />
//               </div>
//               {fieldErrors.captcha && (
//                 <div className="hp-error-text" style={{ marginTop: 8 }}>
//                   {fieldErrors.captcha}
//                 </div>
//               )}
//             </div>

//             {status === "success" && statusMessage && (
//               <div className="hp-status hp-success">{statusMessage}</div>
//             )}
//             {status === "error" && statusMessage && (
//               <div className="hp-status hp-error">{statusMessage}</div>
//             )}

//             <button
//               type="submit"
//               className="hp-submit"
//               disabled={status === "submitting"}
//             >
//               {status === "submitting" ? "Submitting..." : "Submit Application"}
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

import { useState, useEffect, useRef } from "react";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";

export default function HiringPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    address: "",
    phoneNumber: "",
    licenseNumber: "",
    aadharNumber: "",
    description: "",
    jobId: "",
    resume: null,
  });

  const [selectedJob, setSelectedJob] = useState(null);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [status, setStatus] = useState("idle"); // idle | submitting | success | error
  const [statusMessage, setStatusMessage] = useState("");
  const [jobs, setJobs] = useState([]);

  const API_BASE_URL = process.env.REACT_APP_TRACKK_URL;
  const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const captchaRef = useRef(null);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/jobs`);
        const jobsArray = Array.isArray(response.data)
          ? response.data
          : response.data.jobs;
        setJobs(jobsArray.filter((job) => job.status === "Open"));
      } catch (error) {
        console.error("Failed to fetch jobs:", error);
      }
    };
    fetchJobs();
  }, []);

  const validateForm = () => {
    const phoneRegex = /^[0-9]{10}$/;
    const aadharRegex = /^[0-9]{12}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const errors = {};

    if (!phoneRegex.test(formData.phoneNumber)) {
      errors.phoneNumber = "Enter a valid 10-digit phone number.";
    }
    if (!aadharRegex.test(formData.aadharNumber)) {
      errors.aadharNumber = "Enter a valid 12-digit Aadhar number.";
    }
    if (!emailRegex.test(formData.email)) {
      errors.email = "Enter a valid email address.";
    }
    if (!captchaToken) {
      errors.captcha = "Verify the CAPTCHA to continue.";
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    if (fieldErrors[name]) {
      setFieldErrors((prev) => ({ ...prev, [name]: undefined }));
    }

    if (name === "jobId") {
      const job = jobs.find((j) => j._id === value);
      setSelectedJob(job || null);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setFormData((prev) => ({ ...prev, resume: null }));
      return;
    }

    // Allow PDF/DOC/DOCX only
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    if (!allowedTypes.includes(file.type)) {
      setFieldErrors((prev) => ({
        ...prev,
        resume: "Please upload a PDF, DOC, or DOCX file.",
      }));

      e.target.value = "";
      return;
    }

    // Optional: 5 MB limit
    if (file.size > 5 * 1024 * 1024) {
      setFieldErrors((prev) => ({
        ...prev,
        resume: "Resume size should not exceed 5 MB.",
      }));

      e.target.value = "";
      return;
    }

    setFormData((prev) => ({
      ...prev,
      resume: file,
    }));

    setFieldErrors((prev) => ({
      ...prev,
      resume: undefined,
    }));
  };

  const formatPostingDetails = (text) => {
    if (!text) return null;

    // Keep label and value on the same line
    text = text
      .replace(/Experience:\s*\n*\s*/gi, "Experience: ")
      .replace(/Employment Type:\s*\n*\s*/gi, "Employment Type: ")
      .replace(/(Experience:\s*.*?)(\s+Employment Type:)/i, "$1\n$2");

    const sections = [
      "About Us",
      "Key Responsibilities",
      "Required Skills",
      "Preferred",
      "What We Offer",
    ];

    let formatted = text;

    sections.forEach((section) => {
      formatted = formatted.replace(new RegExp(section, "g"), `##${section}##`);
    });

    const parts = formatted.split("##").filter(Boolean);

    return (
      <>
        {/* Experience & Employment Type */}
        {parts[0] && (
          <div style={{ marginBottom: "16px", lineHeight: "1.8" }}>
            {parts[0]
              .trim()
              .split("\n")
              .filter(Boolean)
              .map((line, i) => (
                <div key={i}>{line}</div>
              ))}
          </div>
        )}

        {/* Remaining Sections */}
        {parts.slice(1).map((part, index) => {
          const lines = part
            .split(". ")
            .map((l) => l.trim())
            .filter(Boolean);

          return (
            <div key={index} style={{ marginBottom: "16px" }}>
              <strong>{lines[0]}</strong>

              <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
                {lines.slice(1).map((line, i) => (
                  <li key={i}>{line.replace(/\.$/, "")}</li>
                ))}
              </ul>
            </div>
          );
        })}
      </>
    );
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
    if (token) {
      setFieldErrors((prev) => ({ ...prev, captcha: undefined }));
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!validateForm()) return;

  //   setStatus("submitting");
  //   setStatusMessage("");

  //   try {
  //     const response = await axios.post(
  //       `${API_BASE_URL}/api/v1/applicants`,
  //       { ...formData, captchaToken },
  //       { headers: { "Content-Type": "application/json" } },
  //     );

  //     if (response.status === 201) {
  //       setStatus("success");
  //       setStatusMessage("Application submitted. We'll be in touch soon.");
  //       setFormData({
  //         name: "",
  //         address: "",
  //         phoneNumber: "",
  //         licenseNumber: "",
  //         aadharNumber: "",
  //         description: "",
  //         jobId: "",
  //       });
  //       setSelectedJob(null);
  //       captchaRef.current?.reset();
  //       setCaptchaToken(null);
  //     } else {
  //       setStatus("error");
  //       setStatusMessage("Something went wrong. Please try again.");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setStatus("error");
  //     setStatusMessage(
  //       error.response?.data?.message ||
  //         "Server error. Please check your connection and try again.",
  //     );
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setStatus("submitting");
    setStatusMessage("");

    try {
      const data = new FormData();

      data.append("name", formData.name);
      data.append("email", formData.email);
      data.append("address", formData.address);
      data.append("phoneNumber", formData.phoneNumber);
      data.append("licenseNumber", formData.licenseNumber);
      data.append("aadharNumber", formData.aadharNumber);
      data.append("description", formData.description);
      data.append("jobId", formData.jobId);
      data.append("captchaToken", captchaToken);

      if (formData.resume) {
        data.append("resume", formData.resume);
      }

      const response = await axios.post(
        `${API_BASE_URL}/api/v1/applicants`,
        data,
      );

      if (response.status === 201) {
        setStatus("success");
        setStatusMessage("Application submitted. We'll be in touch soon.");

        setFormData({
          name: "",
          email: "",
          address: "",
          phoneNumber: "",
          licenseNumber: "",
          aadharNumber: "",
          description: "",
          jobId: "",
          resume: null,
        });

        // Reset file input
        const resumeInput = document.getElementById("hp-resume");
        if (resumeInput) {
          resumeInput.value = "";
        }

        setSelectedJob(null);

        captchaRef.current?.reset();
        setCaptchaToken(null);
      } else {
        setStatus("error");
        setStatusMessage("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error(error);

      setStatus("error");

      setStatusMessage(
        error.response?.data?.message ||
          "Server error. Please check your connection and try again.",
      );
    }
  };

  const digitsOnly = (max) => (e) => {
    e.target.value = e.target.value.replace(/\D/g, "").slice(0, max);
  };

  return (
    <div className="hp-page">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@400;500;600&display=swap');

        .hp-page {
          --ink: #10192E;
          --ink-soft: #1B2946;
          --ink-line: rgba(247,245,241,0.14);
          --paper: #F6F4EF;
          --card: #FFFFFF;
          --brass: #C08A3E;
          --brass-dark: #9C6F2E;
          --text: #1B1F27;
          --muted: #6B7280;
          --border: #E4E0D6;
          --success: #2F6F4E;
          --success-bg: #EAF3EC;
          --error: #B3432B;
          --error-bg: #FBECE7;

          font-family: 'Inter', -apple-system, sans-serif;
          background: var(--paper);
          color: var(--text);
          min-height: 100vh;
          padding: 48px 24px;
          box-sizing: border-box;
        }
        .hp-page *, .hp-page *::before, .hp-page *::after { box-sizing: border-box; }

        .hp-shell {
          max-width: 760px;
          margin: 0 auto;
          background: var(--card);
          border-radius: 4px;
          overflow: hidden;
          box-shadow: 0 30px 60px -25px rgba(16,25,46,0.25);
          border: 1px solid var(--border);
        }

        .hp-eyebrow {
          font-family: 'JetBrains Mono', monospace;
          font-size: 11px;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--brass-dark);
          margin: 0 0 10px;
        }

        /* ---------- Job ticket (light, right-aligned, conditional) ---------- */
        .hp-ticket-wrap {
          display: flex;
          justify-content: flex-end;
          grid-column: 1 / -1;
        }
        .hp-ticket {
          width: 100%;
          background: #FBF8F2;
          border-radius: 4px;
          border: 1px solid var(--border);
          overflow: hidden;
          animation: hp-rise 0.3s ease;
        }
        @keyframes hp-rise {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .hp-ticket-top {
          padding: 18px 20px 16px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 12px;
        }
        .hp-ticket-label {
          font-family: 'JetBrains Mono', monospace;
          font-size: 10px;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: var(--brass-dark);
          margin: 0 0 8px;
        }
        .hp-ticket-title {
          font-family: 'Space Grotesk', sans-serif;
          font-size: 18px;
          font-weight: 600;
          margin: 0 0 4px;
          color: var(--text);
        }
        .hp-ticket-city {
          font-size: 13px;
          color: var(--muted);
          margin: 0;
        }
        .hp-ticket-clear {
          background: none;
          border: none;
          font-size: 12px;
          color: var(--muted);
          text-decoration: underline;
          cursor: pointer;
          padding: 2px 0;
          font-family: 'Inter', sans-serif;
          white-space: nowrap;
        }
        .hp-ticket-clear:hover { color: var(--error); }
        .hp-ticket-divider {
          position: relative;
          border-top: 1px dashed var(--border);
        }
        .hp-ticket-divider::before,
        .hp-ticket-divider::after {
          content: "";
          position: absolute;
          top: -9px;
          width: 18px;
          height: 18px;
          background: var(--card);
          border-radius: 50%;
        }
        .hp-ticket-divider::before { left: -9px; }
        .hp-ticket-divider::after { right: -9px; }
        .hp-ticket-bottom {
          padding: 16px 20px 18px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px;
        }
        .hp-ticket-stat-label {
          font-size: 10px;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: var(--muted);
          margin: 0 0 4px;
        }
        .hp-ticket-stat-value {
          font-family: 'JetBrains Mono', monospace;
          font-size: 13.5px;
          color: var(--text);
          margin: 0;
        }
        .hp-ticket-notes {
          padding: 0 20px 20px;
          font-size: 12.5px;
          line-height: 1.6;
          color: var(--muted);
        }

        /* ---------- Form panel ---------- */
        .hp-form-panel { padding: 44px 44px 48px; }
        .hp-form-panel h2 {
          font-family: 'Space Grotesk', sans-serif;
          font-size: 24px;
          font-weight: 600;
          margin: 0 0 6px;
        }
        .hp-form-sub {
          font-size: 13.5px;
          color: var(--muted);
          margin: 0 0 30px;
        }

        .hp-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px 18px;
        }
        .hp-field { display: flex; flex-direction: column; }
        .hp-field.hp-full { grid-column: 1 / -1; }

        .hp-field label {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: var(--muted);
          margin-bottom: 7px;
        }
        .hp-field input,
        .hp-field select,
        .hp-field textarea {
          font-family: 'Inter', sans-serif;
          font-size: 14.5px;
          color: var(--text);
          background: var(--paper);
          border: 1px solid var(--border);
          border-radius: 3px;
          padding: 11px 13px;
          outline: none;
          transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
          width: 100%;
        }
        .hp-field input::placeholder,
        .hp-field textarea::placeholder { color: #A8A398; }
        .hp-mono { font-family: 'JetBrains Mono', monospace; letter-spacing: 0.02em; }

        .hp-field input:focus,
        .hp-field select:focus,
        .hp-field textarea:focus {
          border-color: var(--brass);
          background: var(--card);
          box-shadow: 0 0 0 3px rgba(192,138,62,0.16);
        }
        .hp-field.hp-invalid input,
        .hp-field.hp-invalid select {
          border-color: var(--error);
        }
        .hp-error-text {
          font-size: 12px;
          color: var(--error);
          margin-top: 6px;
        }
        .hp-field textarea { resize: vertical; min-height: 78px; }

        .hp-captcha-block { margin-top: 26px; }
        .hp-captcha-wrap { display: inline-block; }

        .hp-status {
          margin-top: 20px;
          padding: 12px 14px;
          border-radius: 3px;
          font-size: 13.5px;
          line-height: 1.5;
        }
        .hp-status.hp-success { background: var(--success-bg); color: var(--success); }
        .hp-status.hp-error { background: var(--error-bg); color: var(--error); }

        .hp-submit {
          margin-top: 26px;
          width: 100%;
          background: var(--ink);
          color: #F7F5F1;
          border: none;
          border-radius: 3px;
          padding: 14px 20px;
          font-family: 'Space Grotesk', sans-serif;
          font-size: 14.5px;
          font-weight: 600;
          letter-spacing: 0.02em;
          cursor: pointer;
          transition: background 0.15s ease, transform 0.1s ease;
        }
        .hp-submit:hover:not(:disabled) { background: var(--brass-dark); }
        .hp-submit:active:not(:disabled) { transform: translateY(1px); }
        .hp-submit:disabled { opacity: 0.6; cursor: not-allowed; }
        .hp-submit:focus-visible { outline: 2px solid var(--brass); outline-offset: 2px; }

        @media (prefers-reduced-motion: reduce) {
          .hp-ticket { animation: none; }
        }
      `}</style>

      <div className="hp-shell">
        <div className="hp-form-panel">
          <p className="hp-eyebrow">Careers · Application</p>
          <h2>Job Application</h2>
          <p className="hp-form-sub">
            Fields marked required must be completed before you can submit.
          </p>

          <form onSubmit={handleSubmit} noValidate>
            <div className="hp-grid">
              <div className="hp-field">
                <label htmlFor="hp-name">Full Name</label>
                <input
                  id="hp-name"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="John Doe"
                  required
                />
              </div>

              <div
                className={`hp-field ${fieldErrors.email ? "hp-invalid" : ""}`}
              >
                <label htmlFor="hp-email">Email</label>

                <input
                  id="hp-email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="john.doe@example.com"
                  required
                />

                {fieldErrors.email && (
                  <span className="hp-error-text">{fieldErrors.email}</span>
                )}
              </div>

              <div className="hp-field">
                <label htmlFor="hp-phone">Phone</label>
                <input
                  id="hp-phone"
                  type="tel"
                  inputMode="numeric"
                  name="phoneNumber"
                  className="hp-mono"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  onInput={digitsOnly(10)}
                  placeholder="1234567890"
                  required
                />
                {fieldErrors.phoneNumber && (
                  <span className="hp-error-text">
                    {fieldErrors.phoneNumber}
                  </span>
                )}
              </div>

              <div className="hp-field">
                <label htmlFor="hp-job">Job</label>
                <select
                  id="hp-job"
                  name="jobId"
                  value={formData.jobId}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a job</option>
                  {jobs.map((job) => (
                    <option key={job._id} value={job._id}>
                      {job.title} - {job.city}
                    </option>
                  ))}
                </select>
              </div>

              <div className="hp-field hp-full">
                <label htmlFor="hp-address">Address</label>
                <input
                  id="hp-address"
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="123 Main St"
                  required
                />
              </div>

              <div
                className={`hp-field ${fieldErrors.aadharNumber ? "hp-invalid" : ""}`}
              >
                <label htmlFor="hp-aadhar">Aadhar Number</label>
                <input
                  id="hp-aadhar"
                  type="tel"
                  inputMode="numeric"
                  name="aadharNumber"
                  className="hp-mono"
                  value={formData.aadharNumber}
                  onChange={handleChange}
                  onInput={digitsOnly(12)}
                  placeholder="123412341234"
                  required
                />
                {fieldErrors.aadharNumber && (
                  <span className="hp-error-text">
                    {fieldErrors.aadharNumber}
                  </span>
                )}
              </div>

              <div className="hp-field">
                <label htmlFor="hp-license">License Number</label>
                <input
                  id="hp-license"
                  type="text"
                  name="licenseNumber"
                  className="hp-mono"
                  value={formData.licenseNumber}
                  onChange={handleChange}
                  placeholder="AB1234567"
                  required
                />
              </div>

              {selectedJob && (
                <div className="hp-ticket-wrap">
                  <div className="hp-ticket">
                    <div className="hp-ticket-top">
                      <div>
                        <p className="hp-ticket-label">Selected Posting</p>
                        <h3 className="hp-ticket-title">{selectedJob.title}</h3>
                        <p className="hp-ticket-city">{selectedJob.city}</p>
                      </div>
                      <button
                        type="button"
                        className="hp-ticket-clear"
                        onClick={() => {
                          setSelectedJob(null);
                          setFormData((prev) => ({ ...prev, jobId: "" }));
                        }}
                      >
                        Clear
                      </button>
                    </div>
                    <div className="hp-ticket-divider" />
                    <div className="hp-ticket-bottom">
                      <div>
                        <p className="hp-ticket-stat-label">Openings</p>
                        <p className="hp-ticket-stat-value">
                          {selectedJob.openings}
                        </p>
                      </div>
                    </div>
                    {selectedJob.postingdetails && (
                      <div className="hp-ticket-notes">
                        {formatPostingDetails(selectedJob.postingdetails)}
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="hp-field hp-full">
                <label htmlFor="hp-description">
                  Description{" "}
                  <span style={{ textTransform: "none", fontWeight: 400 }}>
                    (optional)
                  </span>
                </label>
                <textarea
                  id="hp-description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Tell us about yourself..."
                  rows={3}
                />
              </div>

              <div className="hp-field hp-full">
                <label htmlFor="hp-resume">Resume</label>

                <input
                  id="hp-resume"
                  type="file"
                  name="resume"
                  accept=".pdf,.doc,.docx"
                  onChange={handleFileChange}
                  required
                />

                {fieldErrors.resume && (
                  <span className="hp-error-text">{fieldErrors.resume}</span>
                )}
              </div>
            </div>

            <div className="hp-captcha-block">
              <div className="hp-captcha-wrap">
                <ReCAPTCHA
                  sitekey={SITE_KEY}
                  onChange={handleCaptchaChange}
                  ref={captchaRef}
                />
              </div>
              {fieldErrors.captcha && (
                <div className="hp-error-text" style={{ marginTop: 8 }}>
                  {fieldErrors.captcha}
                </div>
              )}
            </div>

            {status === "success" && statusMessage && (
              <div className="hp-status hp-success">{statusMessage}</div>
            )}
            {status === "error" && statusMessage && (
              <div className="hp-status hp-error">{statusMessage}</div>
            )}

            <button
              type="submit"
              className="hp-submit"
              disabled={status === "submitting"}
            >
              {status === "submitting" ? "Submitting..." : "Submit Application"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

